<template>
  <div>
    <div>
      <breadcrumb :breadcrumb_link="pacific_breadcrumb" />
    </div>
    <div class="outterBox">
      <div class="header">
        <!--      <h1 class="overlay">SPECIAL SOUVENIR</h1>-->
        <!--      <img src="@/assets/images/Podohotel/about_headerimage.jpg" />-->
        <div class="headerimage" />
      </div>

      <div class="container contentDesc">
        <div class="title1">
          <div class="titleDesc col-lg-12 text-center">
            <div style="color: #b9b1b1; margin-bottom: 10px">{{ $t('benefit_program_subtitle') }}</div>
          </div>
          <h2>
            <strong>{{ $t('benefit_program_title') }}</strong>
          </h2>
        </div>
      </div>
      <div class="container">
        <div class="aquaplanet_header row d-flex justify-content-center">
          <!--          <div>-->
          <!--            &lt;!&ndash;          <div class="overlay"><h1>SPECIAL BENEFITS</h1></div>&ndash;&gt;-->
          <!--            <img src="@/assets/images/Podohotel/benefitinfo_headerimage.png" />-->
          <!--          </div>-->
          <!--          <div class="wedding_body_hedaer text-center col-lg-12 mt-5 mb-4">-->
          <!--            <h2><strong>한화 아쿠아플라넷 제주</strong></h2>-->
          <!--          </div>-->

          <img class="imageStyle" src="@/assets/images/Podohotel/benefitinfo_pacific_image.jpg" />
        </div>

        <div class="row d-inline-block pt-5 pb-5 p-2">
          <div class="mb-5">
            <div class="mx-5">
              {{ $t('benefit_program_desc') }}
            </div>
          </div>
          <hr />
          <table class="table table-borderless mt-5 mx-auto col-lg-8 col-12">
            <tbody>
              <tr class="d-flex flex-column mb-4">
                <td class="font-weight-bold">{{ $t('benefit_program_table_td1') }}</td>
                <td>{{ $t('benefit_program_table_td2') }}</td>
              </tr>
              <tr class="d-flex flex-column mb-4">
                <td class="font-weight-bold">{{ $t('benefit_program_table_td3') }}</td>
                <td>{{ $t('benefit_program_table_td4') }}</td>
              </tr>
              <tr class="d-flex flex-column mb-4">
                <td class="font-weight-bold">{{ $t('benefit_program_table_td5') }}</td>
                <td>{{ $t('benefit_program_table_td6') }}</td>
              </tr>
              <tr class="d-flex flex-column mb-4">
                <td class="font-weight-bold">{{ $t('benefit_program_table_td7') }}</td>
                <td>{{ $t('benefit_program_table_td8') }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb';

export default {
  name: 'Pacific',
  data() {
    return {
      pacific_breadcrumb: {
        toplink: 'HOME',
        prevlink: 'SPECIAL OFFERS',
        present: this.$t('breadcrumb'),
      },
      isLang: 0,
    };
  },
  methods: {
    refreshLocale(newVal) {
      if (newVal === 'ko') {
        this.isLang = 0;
      } else if (newVal === 'en') {
        this.isLang = 1;
      } else if (newVal === 'ja') {
        this.isLang = 2;
      } else {
        this.isLang = 0;
      }

      if (this.isLang === 0) {
        this.pacific_breadcrumb.prevlink = 'SPECIAL OFFERS > 제휴사 혜택 안내';
      } else {
        this.pacific_breadcrumb.prevlink = 'SPECIAL OFFERS > PARTNERSHIP';
      }

      this.$store.dispatch('Display/changeName', {name: this.$t('breadcrumb')});
    },
  },
  watch: {
    '$i18n.locale'(newVal, oldVal) {
      this.refreshLocale(newVal);
    },
  },
  async created() {
    this.refreshLocale(this.$i18n.locale);
  },
  mounted() {
    this.$store.dispatch('Display/changeName', {name: this.$t('breadcrumb')});
  },
  components: {Breadcrumb},
};
</script>

<style scoped lang="scss">
.table h5 {
  margin: 0;
}
.table td {
  padding: 5px;
}

h5 {
  word-break: keep-all;
}

.main-ex-desc {
  vertical-align: bottom;
}

.header {
  position: relative;
  width: 100%;
  padding-top: 0rem;
  > img {
    width: 100%;
  }

  .overlay {
    padding-top: 0rem;
    color: White;
    position: absolute;
    text-align: center;
    z-index: 12;
    width: 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-weight: lighter;
    letter-spacing: -0.1rem;
  }

  .headerimage {
    display: block;
    width: 100%;
    margin: 0;
    content: url('~@/assets/images/Podohotel/benefitinfo_headerimage.png');
  }
}

.contentDesc {
  padding-top: 3rem;
  padding-bottom: 3rem;
  text-align: center;
}

.outterBox {
}

@media (max-width: 992px) {
  .header {
    display: none;
  }
  .outterBox {
    padding-top: 5rem;
  }

  h2 {
    font-size: 1.5rem !important;
  }

  h3 {
    font-size: 1.3rem !important;
  }

  h4 {
    font-size: 1rem !important;
  }

  h5 {
    line-height: 1.6rem !important;
    font-size: 1rem !important;
  }

  .imageStyle {
    width: 100%;
  }
}
</style>

<i18n>
{
  "ko": {
    "breadcrumb": "퍼시픽 마리나",
    "benefit_program_subtitle" : "더 가까이 더 즐거운 요트투어",
    "benefit_program_title" : "퍼시픽 마리나",
    "benefit_program_desc" : "퍼시픽 마리나 요트투어는 4계절 내내 운항하며 연중 많은 분들께 사랑받고 있습니다. 중문의 주상절리, 범섬, 형제섬, 가파도와 마라도까지 탐험 가능하며, 12인승 중형요트와 26인승의 대형요트를 구비하고 있습니다. 안전을 최우선하는 퍼시픽 마리나 요트투어와 함께 잊지 못할 제주여행 되세요.",
    "benefit_program_table_td1" : "할인혜택",
    "benefit_program_table_td2" : "요트&제트보트 30% 할인",
    "benefit_program_table_td3" : "이용방법",
    "benefit_program_table_td4" : "영수증 및 객실 키 제시",
    "benefit_program_table_td5" : "주소",
    "benefit_program_table_td6" : "제주특별자치도 서귀포시 중문관광로 154-17",
    "benefit_program_table_td7" : "문의번호",
    "benefit_program_table_td8" : "1544-2988"
  },
  "en": {
    "breadcrumb": "Pacific Marina",
    "benefit_program_subtitle" : "더 가까이 더 즐거운 요트투어",
    "benefit_program_title" : "퍼시픽 마리나",
    "benefit_program_desc" : "퍼시픽 마리나 요트투어는 4계절 내내 운항하며 연중 많은 분들께 사랑받고 있습니다. 중문의 주상절리, 범섬, 형제섬, 가파도와 마라도까지 탐험 가능하며, 12인승 중형요트와 26인승의 대형요트를 구비하고 있습니다. 안전을 최우선하는 퍼시픽 마리나 요트투어와 함께 잊지 못할 제주여행 되세요.",
    "benefit_program_table_td1" : "할인혜택",
    "benefit_program_table_td2" : "요트&제트보트 30% 할인",
    "benefit_program_table_td3" : "이용방법",
    "benefit_program_table_td4" : "영수증 및 객실 키 제시",
    "benefit_program_table_td5" : "주소",
    "benefit_program_table_td6" : "제주특별자치도 서귀포시 중문관광로 154-17",
    "benefit_program_table_td7" : "문의번호",
    "benefit_program_table_td8" : "1544-2988"
  },
  "ja": {
  }
}
</i18n>
